import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./recipes.css";
import Recipie from "../../components/recipie/Recipie";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import Img4 from "./img4.png";
import Img5 from "./img5.png";
import Img6 from "./img6.png";
import Img7 from "./img7.png";
import Img8 from "./img8.png";
import Img9 from "./img9.png";
import Img10 from "./img10.png";
import Img11 from "./img11.png";
import Img12 from "./img12.png";
import Img13 from "./img13.png";
import Img14 from "./img14.png";
import Img15 from "./img15.png";
// import Imgbg from "./imgbg.png";
const Recipes = () => {
  return (
    <>
      <Navb />
      <div className="recipestop">Recipies</div>
      <div className="recipiestopNanditext">
        <div className="recipiestopNanditextHeading">Nandi Agro Recipe</div>
        <div className="recipiestopNanditextP">
          Explore the culinary possibilities with Ecavo by Nandi Agro, where
          every recipe is a celebration of flavor and nutrition. From classic
          favorites to innovative creations, our collection of recipes showcases
          the versatility of Nandi Gram Flour. Indulge in the crispy goodness of
          Pakoras, savour the aromatic delights of Bhajis, or satisfy your sweet
          tooth with our irresistible Ladoo recipes. With Nandi, culinary
          excellence is at your fingertips. Get ready to delight your taste buds
          and nourish your body with our inspired recipes, crafted with care and
          passion by Nandi Agro.
        </div>
      </div>
      <div className="recipeCover">
        <div className="homeRecipies">
          <Recipie
            IMG={Img14}
            RecipieName="Atta Momos"
            RecipieLink="wholeattavegmomos"
          />
          <Recipie
            IMG={Img2}
            RecipieName="Mix Veg Paratha"
            RecipieLink="mixvegparatha"
          />
          <Recipie
            IMG={Img3}
            RecipieName="Biscuit"
            RecipieLink="wholeattacookies"
          />
          {/* </div>
        <div className="homeRecipies"> */}
          <Recipie
            IMG={Img4}
            RecipieName="Maida Pizza Cone"
            RecipieLink="maidavegpizzacones"
          />
          <Recipie
            IMG={Img13}
            RecipieName="Nandi Sabji Masala"
            RecipieLink="nandisabjimasala"
          />
          {/* <Recipie IMG={Img5} RecipieName="Spring Roll" RecipieLink="wholeattavegmomos" /> */}
          <Recipie
            IMG={Img6}
            RecipieName="Besan Kadhi & Rice"
            RecipieLink="besankadhirice"
          />
          {/* </div>
        <div className="homeRecipies"> */}
          <Recipie
            IMG={Img7}
            RecipieName="Besan burfi "
            RecipieLink="besanburfi"
          />
          <Recipie
            IMG={Img8}
            RecipieName="Sooji and Veg Cheela"
            RecipieLink="sojivegcheela"
          />
          <Recipie
            IMG={Img15}
            RecipieName="Sooji Dhokla"
            RecipieLink="soojidhokla"
          />
          {/* <Recipie IMG={Img9} RecipieName="Sooji Dhokla" RecipieLink="wholeattavegmomos" /> */}
          {/* </div>
        <div className="homeRecipies"> */}
          <Recipie
            IMG={Img10}
            RecipieName="Dalia Salad"
            RecipieLink="daliasalad"
          />
          <Recipie
            IMG={Img11}
            RecipieName="Dalia Khichadi"
            RecipieLink="daliakhichadi"
          />
          {/* <Recipie IMG={Img12} RecipieName="Nandi Meat Masala Curry" RecipieLink="wholeattavegmomos" /> */}
          {/* </div>
        <div className="homeRecipies"> */}
          {/* <Recipie IMG={Img11} RecipieName="Mix Veg Paratha" RecipieLink="wholeattavegmomos" />
          <Recipie IMG={Img12} RecipieName="Biscuit" RecipieLink="wholeattavegmomos" /> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Recipes;
